import React from 'react';
import { MapPin, Building2, TrendingUp, Users, BarChart3 } from 'lucide-react';

const CommuneStats = ({ stats }) => {
  const { commune: communeStats, property: propertyStats } = stats;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {/* Total Communes */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Total Communes</p>
            <p className="text-2xl font-bold text-gray-900">{communeStats?.length || 0}</p>
          </div>
          <div className="h-12 w-12 bg-blue-100 rounded-lg flex items-center justify-center">
            <MapPin className="h-6 w-6 text-blue-600" />
          </div>
        </div>
        <div className="mt-4">
          <div className="flex items-center text-sm text-gray-600">
            <BarChart3 className="h-4 w-4 mr-1" />
            Répartis dans {new Set(communeStats?.map(c => c?.district))?.size} districts
          </div>
        </div>
      </div>

      {/* Total Properties */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Total Propriétés</p>
            <p className="text-2xl font-bold text-gray-900">{propertyStats?.total || 0}</p>
          </div>
          <div className="h-12 w-12 bg-green-100 rounded-lg flex items-center justify-center">
            <Building2 className="h-6 w-6 text-green-600" />
          </div>
        </div>
        <div className="mt-4">
          <div className="flex items-center text-sm text-gray-600">
            <TrendingUp className="h-4 w-4 mr-1" />
            {propertyStats?.byStatus?.available || 0} disponibles
          </div>
        </div>
      </div>

      {/* Average Population */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Pop. Moyenne</p>
            <p className="text-2xl font-bold text-gray-900">
              {communeStats?.length > 0 ? 
                Math.round(communeStats?.reduce((sum, c) => sum + (c?.totalPopulation || 0), 0) / communeStats?.length)?.toLocaleString() : 
                '0'
              }
            </p>
          </div>
          <div className="h-12 w-12 bg-purple-100 rounded-lg flex items-center justify-center">
            <Users className="h-6 w-6 text-purple-600" />
          </div>
        </div>
        <div className="mt-4">
          <div className="flex items-center text-sm text-gray-600">
            <Users className="h-4 w-4 mr-1" />
            Par commune
          </div>
        </div>
      </div>

      {/* Average Property Price */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Prix Moyen</p>
            <p className="text-2xl font-bold text-gray-900">
              {propertyStats?.avgPrice ? 
                `${(propertyStats?.avgPrice / 1000000)?.toFixed(1)}M` : 
                '0'
              }
            </p>
          </div>
          <div className="h-12 w-12 bg-yellow-100 rounded-lg flex items-center justify-center">
            <TrendingUp className="h-6 w-6 text-yellow-600" />
          </div>
        </div>
        <div className="mt-4">
          <div className="flex items-center text-sm text-gray-600">
            <TrendingUp className="h-4 w-4 mr-1" />
            FCFA par propriété
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommuneStats;